/*!
 * SF Zero — Shipping Progress Bar v3.2
 * - Free shipping at $70
 * - Subscription items = automatic free shipping
 * - English only
 * - Light theme: matches white cart background
 * - Centered text, symmetric truck pin
 */

(function(){
  var FREE = 70;

  var LOCALE = 'en-US';
  var CURRENCY = 'USD';

  function getCurrencyFromShopify(){
    try{
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return String(Shopify.currency.active).toUpperCase();
      }
    }catch(e){}
    return null;
  }

  function localeFromCurrency(currency){
    if (currency === 'USD') return 'en-US';
    if (currency === 'GBP') return 'en-GB';
    if (currency === 'EUR') return 'en-IE';
    if (currency === 'CAD') return 'en-CA';
    if (currency === 'AUD') return 'en-AU';
    return 'en-US';
  }

  function rebuildFormatter(){
    LOCALE = localeFromCurrency(CURRENCY || 'USD');
    return new Intl.NumberFormat(LOCALE, {
      style:'currency',
      currency:(CURRENCY || 'USD'),
      minimumFractionDigits:2
    });
  }

  var fmt = rebuildFormatter();

  var T = {
    head_under:        function(a){ return `Only ${a} away from free shipping`; },
    head_free:         function(){ return `You've unlocked free shipping`; },
    head_subscription: function(){ return `Free shipping with your subscription`; }
  };

  // ───── CSS ─────
  (function injectCSS(){
    if (document.getElementById('spb-sfz-styles-v320')) return;
    var css = `
      .drawer__fixed-header{ overflow: visible; }

      .spb-wrap{
        background: #F9F4ED;
        border-bottom: 1px solid #E8DDD0;
        padding: 14px 18px 16px;
        margin: 0;
      }

      .spb{
        --spb-cacao: #2A1810;
        --spb-cacao-soft: #5C4A3D;
        --spb-honey: #C89755;
        --spb-honey-dark: #A77D40;
        --spb-cream-soft: #E8DDD0;
        --spb-bar-h: 6px;
        --spb-pin-s: 28px;
        --spb-pin-inset: 14px;
        font-family: inherit;
        color: var(--spb-cacao);
      }
      .spb[hidden]{ display:none !important; }

      .spb__textwrap{
        margin: 0 0 calc((var(--spb-pin-s) - var(--spb-bar-h))/2 + 6px);
        text-align: center;
      }
      .spb__head{
        font-size: .82rem;
        line-height: 1.25;
        font-weight: 600;
        margin: 0;
        color: var(--spb-cacao);
        letter-spacing: -0.1px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .spb.is-free .spb__head{
        color: var(--spb-honey-dark);
      }

      .spb__bar{
        position: relative;
        height: var(--spb-bar-h);
        background: var(--spb-cream-soft);
        border-radius: 999px;
        overflow: visible;
        margin: 0 var(--spb-pin-inset);
      }
      .spb__fill{
        position: absolute;
        left: 0; top: 0;
        height: 100%;
        width: 0;
        background: var(--spb-honey);
        border-radius: inherit;
        transition: width .25s ease, background-color .2s ease;
      }
      .spb.is-free .spb__fill{
        background: var(--spb-honey-dark);
      }

      .spb__pin{
        position: absolute;
        top: 50%;
        width: var(--spb-pin-s);
        height: var(--spb-pin-s);
        border-radius: 999px;
        display: grid;
        place-items: center;
        background: #FFFFFF;
        border: 1.5px solid var(--spb-honey);
        box-shadow: 0 2px 8px rgba(42,24,16,0.12);
        font-size: calc(var(--spb-pin-s) * .48);
        line-height: 1;
        z-index: 1;
        pointer-events: none;
      }
      .spb__pin--free{
        right: 0;
        transform: translate(50%, -50%);
      }
      .spb.is-free .spb__pin--free{
        background: var(--spb-honey);
        border-color: var(--spb-honey-dark);
      }

      @media (max-width: 420px){
        .spb-wrap{ padding: 12px 14px 14px; }
        .spb{ --spb-pin-s: 26px; --spb-pin-inset: 13px; }
        .spb__head{ font-size: .78rem; }
      }
    `.trim();
    var style = document.createElement('style');
    style.id = 'spb-sfz-styles-v320';
    style.textContent = css;
    document.head.appendChild(style);
  })();

  function mountEl(){
    var el = document.getElementById('ShippingProgressMount');
    if (!el) return null;
    return el;
  }

  function hasSubscriptionItem(cart){
    if (!cart || !cart.items) return false;
    return cart.items.some(function(it){
      return it.selling_plan_allocation != null;
    });
  }

  function render(cart){
    var mount = mountEl();
    if (!mount) return;

    var total = ((cart && cart.total_price) || 0) / 100;

    if (total <= 0){
      mount.style.display = 'none';
      return;
    }
    mount.style.display = '';

    var isSubscription = hasSubscriptionItem(cart);
    var isFree = isSubscription || total >= FREE;

    var headHTML = '';
    var pct = 0;

    if (isSubscription){
      headHTML = T.head_subscription();
      pct = 100;
    } else if (isFree){
      headHTML = T.head_free();
      pct = 100;
    } else {
      headHTML = T.head_under(fmt.format(FREE - total));
      pct = Math.min(total / FREE * 100, 96);
    }

    mount.innerHTML = `
      <div class="spb-wrap">
        <section class="spb ${isFree ? 'is-free' : ''}">
          <div class="spb__textwrap">
            <p class="spb__head">${headHTML}</p>
          </div>
          <div class="spb__bar" role="progressbar" aria-valuemin="0" aria-valuemax="${FREE}" aria-valuenow="${Math.min(total, FREE)}">
            <div class="spb__fill" style="width:${pct}%"></div>
            <div class="spb__pin spb__pin--free" aria-hidden="true">🚚</div>
          </div>
        </section>
      </div>
    `;
  }

  function refresh(){
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){
        var detectedCurrency =
          getCurrencyFromShopify() ||
          (c && c.currency ? String(c.currency).toUpperCase() : null) ||
          'USD';

        if (detectedCurrency !== CURRENCY){
          CURRENCY = detectedCurrency;
          fmt = rebuildFormatter();
        }

        render(c);
      })
      .catch(function(){ /* noop */ });
  }

  document.addEventListener('DOMContentLoaded',  refresh);
  document.addEventListener('cart:updated',      refresh);
  document.addEventListener('ajaxProduct:added', refresh);
  document.addEventListener('ajaxCart:cartUpdate', refresh);
  document.addEventListener('cart:refresh',      refresh);
  document.addEventListener('cart:rendered',     refresh);
  document.addEventListener('ajaxProduct:removed', refresh);

  refresh();
  setTimeout(refresh, 80);
})();